export default "__VITE_ASSET__YIhea6E4__"